
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApplicationDocument } from '@/commons/types'
import {
    MediatedIssuanceService
} from '@/store/services/mediated.issuance.service'
import { GeneralError } from '@/store/entities'
import { MediatedPrice } from '@/commons/types/mediated.price'

@Component
export default class ModalBoxMediatedIssuanceContent extends Vue {
    @Prop() closeCallback!: () => void
    @Prop() applicationDocument!: ApplicationDocument
    mediatedPrices: Array<MediatedPrice> | null = []

    async mediatedIssuancePrices (): Promise<void> {
        try {
            this.mediatedPrices = await MediatedIssuanceService.fetchPrices()
        } catch {
            throw new GeneralError(['errors.system.title'])
        }
    }

    getPriceLabelText (label: string): string {
        return MediatedIssuanceService.getPriceLabelText(label)
    }

    cancel (): void {
        this.closeCallback()
    }

    mounted (): void {
        this.mediatedIssuancePrices()
    }
}
